import * as marietta from '../..';

// Menu categories in 3D
export default class ItemChangeMenuCategories3d {
  _currentMenuID: string;

  get currentMenuID() {
    return this._currentMenuID;
  }

  set currentMenuID(id: string) {
    this._currentMenuID = id;
  }

  /**
   * コンストラクタ
   */
  constructor() {
    this.reset();
    // [3D]左メニューボタンイベントの設定
    document
      .getElementById('itemChangeMenuWrap')
      .querySelectorAll('.leftMenuCategories')
      .forEach((element) => {
        element.querySelectorAll('input').forEach((elem) => {
          elem.addEventListener('change', this.changeItemMenu);
        });
      });
  }

  /**
   * 初期状態に戻す
   */
  reset = () => {
    this.currentMenuID = null;

    // 左メニューの表示初期化
    document
      .getElementById('itemChangeMenuWrap')
      .querySelectorAll('.leftMenuCategories')
      .forEach((element) => {
        element.querySelectorAll('input').forEach((elem) => {
          // eslint-disable-next-line no-param-reassign
          elem.checked = false;
        });
      });
    // 表示中のダイアログがあれば閉じる
    if (marietta.webcad.WebCADGlobal.currentDialog) marietta.webcad.WebCADGlobal.currentDialog.close();

    // 左メニューを全て閉じる
    this.hideAllMenu();
  };

  timeoutID;

  /**
   * 表示するメニューの変更
   */
  changeItemMenu = (e: Event) => {
    const self = this;
    e.preventDefault();

    // 選択ボタンの解除
    document.getElementById('checkSelectMode').classList.remove('is-active');

    // 表示するメニューのIDを取得
    const targetID = `itemChangeMenu_${(<HTMLElement>e.currentTarget).getAttribute('value')}`;

    console.log(this.timeoutID);
    clearTimeout(this.timeoutID);
    // 表示しているメニューの有無を判別
    if (this.currentMenuID) {
      // アイテムメニューを全て非表示に
      this.hideAllMenu();

      // 対象のメニューを表示(アニメーション)
      this.timeoutID = setTimeout(() => {
        self.showMenu(targetID);
      }, 500);
    } else {
      this.showMenu(targetID);
    }
  };

  /**
   * アイテムメニューを全て隠す
   */
  hideAllMenu = () => {
    // offsetWidth値を取得するために、displayプロパティをvisibilityに変更します。
    // if (document.getElementById('itemChangeMenuWrap').style.display === 'none') {
    //   document.getElementById('itemChangeMenuWrap').style.visibility = 'hidden';
    // } else {
    //   document.getElementById('itemChangeMenuWrap').style.visibility = 'visible';
    // }
    // document.getElementById('itemChangeMenuWrap').style.display = 'block';

    // アニメーション
    document.getElementById('itemChangeMenuWrap').querySelectorAll('.itemMenu').forEach((elem) => {
      const element = elem;
      const w = getComputedStyle(<HTMLElement>element).width;
      (<HTMLElement>element).style.transform = `translateX(-${w})`;
    });

    // $('#itemChangeMenuWrap .itemMenu').each(function () {
    //   const w = $(this).outerWidth();
    //   $(this).css({
    //     transform: `translateX(-${w}px)`,
    //   });
    // });
    // offsetWidth計算後、visibilityプロパティをdisplayに変更します
    // if (document.getElementById('itemChangeMenuWrap').style.visibility === 'hidden') {
    //   document.getElementById('itemChangeMenuWrap').style.display = 'none';
    // } else {
    //   document.getElementById('itemChangeMenuWrap').style.display = 'block';
    // }
    // document.getElementById('itemChangeMenuWrap').style.visibility = 'visible';

    // フッターの横幅をリサイズ
    const footer: HTMLElement = document.getElementById('footerMenuQuotationList');
    footer.style.width = 'calc(100% - 50px)';
    // footer.style.transform = 'translate(0px, calc(100% - 18px))';

    const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));
    // eslint-disable-next-line no-undef
    const matrix = new WebKitCSSMatrix(style.transform);
    document.getElementById('footerMenuQuotationList').style.transform = `translate(0px, ${matrix.m42}px)`;
    // if (marietta.webcad.WebCADGlobal.quotationItemList) marietta.webcad.WebCADGlobal.quotationItemList.footerListOpen = false;

    this.currentMenuID = null;
  };

  /**
   * アイテムメニューを表示
   */
  showMenu = (targetID: string) => {
    // アニメーション
    if (document.getElementById(targetID)) {
      document.getElementById(targetID).style.transform = 'translateX(-0px)';
      // 展開した左のメニューの横幅に合わせてフッターの横幅をリサイズ
      const footer: HTMLElement = document.getElementById('footerMenuQuotationList');
      footer.style.width = `calc(100% - ${document.getElementById(targetID).offsetWidth}px - 50px)`;
      const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));
      // eslint-disable-next-line no-undef
      const matrix = new WebKitCSSMatrix(style.transform);
      document.getElementById('footerMenuQuotationList').style.transform = `translate(${document.getElementById(targetID).offsetWidth}px, ${matrix.m42}px)`;
      marietta.webcad.WebCADGlobal.quotationItemList.footerListOpen = (matrix.m42 === 15);
    }
    this.currentMenuID = targetID;
  };
}
